fx.ns("shared.stage", class CoverBinding extends fx.Component {

    constructor(book, page)
	{
        super(book);

        this.page = page;
        this.book = book;
        this.pointerEvents = false;
    }

  

    onReady()
    {
        super.onReady()

        if (this.page && this.page.isCover)
            this.addClass( "cover" );// type;

        this._updateSlice();
    }

    onDataEvent(e)
    {
        if (e.type == "cover-updated")
        {
            this.update();
            this._updateSlice()
        }
            
    }

    _updateSlice()
    {
        if (this.page && this.page.isCover && this.book.hasSlice)
            this.toolTip = this.book.sliceText;

        this.attr("covertype", this.data.cover_option);
    }

    render()
    {
        let html = '<div class="content">';

        if (this.data)
        {
            if (this.data.cover_option == models.ProductBook.BIND)
            {
                if (this.page && this.page.isCover)
                    html +='<div class="bind-container"><div class="bind"></div></div><div class="bind-container"><div class="bind"></div></div>';
            }
            else
            if (this.data.cover_option == models.ProductBook.SPIRAL)
            {
                let numberSpirals;
                switch(this.data.shape_option)
                {
                    case "square" : 
                        numberSpirals = 16;
                        break;
                    case "landscape" : 
                        numberSpirals =  16;
                        break;
                    case "portrait" : 
                    default:
                        numberSpirals =  23;
                        break;
                }
                
                for (let i = 0; i < numberSpirals; i++)
                    html +='<div class="element"><div class="whole left"></div><div class="arc"></div><div class="whole right"></div></div>';
            }
        }
        
        html += '</div>';
        return html;
    }

});